import {combineReducers} from '@reduxjs/toolkit';

import {excelPluginUsageReportReducer} from './reports/excel-plugin-usage-report';
import {usageReportReducer} from './reports/usage-report';

export const reportsReducer = combineReducers({
    usageReport: usageReportReducer,
    excelPluginUsageReport: excelPluginUsageReportReducer,
});
